import { createFileRoute } from '@tanstack/react-router';

import { useTelegramBackButton } from '@common/hooks';
import { Page } from '@common/ui/Page';

import { Tasks } from '@widgets/profile/components';

export const Route = createFileRoute('/tasks')({
  component: Component,
});

export default function Component() {
  useTelegramBackButton({ to: 'back' });

  return (
    <>
      <Page style={{ padding: '8px 0', gridGap: '8px' }}>
        <Tasks />
      </Page>
    </>
  );
}
